<div class="container mx-auto p-4 h-[calc(100vh-100px)] flex flex-col mt-20">
  <div class="flex justify-between items-center mb-6 flex-shrink-0">
    <div class="flex items-center">
      <button (click)="goBack()" class="mr-4 text-gray-600 hover:text-gray-800 transition-colors">
        <i class="fas fa-arrow-left text-xl"></i>
      </button>
      <div>
        <h1 class="text-2xl font-bold text-gray-800 mb-2">Gestión de Paquetes Existentes</h1>
        <p class="text-gray-600">Visualiza, edita y elimina paquetes existentes.</p>
      </div>
    </div>
  </div>

  <!-- Loading spinner con barra de progreso (Global) -->
  <div *ngIf="loading" class="flex flex-col justify-center items-center py-8 flex-1">
    <div class="animate-spin rounded-full h-12 w-12 border-b-4 border-blue-600 mb-4"></div>
    <div class="w-64 bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 overflow-hidden">
      <div class="bg-blue-600 h-2.5 rounded-full transition-all duration-1000 ease-linear" [style.width]="loadingProgress + '%'"></div>
    </div>
    <p class="text-gray-500 mt-2 text-sm">Cargando paquetes... {{loadingProgress}}%</p>
  </div>

  <!-- Contenido Principal -->
  <div *ngIf="!loading" class="flex-1 min-h-0 grid grid-cols-1 lg:grid-cols-2 gap-6">
    <!-- Lista de paquetes (Panel Izquierdo) -->
    <div class="bg-white rounded-lg shadow-md p-6 flex flex-col min-h-0">
      <div class="flex justify-between items-center mb-4 flex-shrink-0">
        <h2 class="text-xl font-semibold">Paquetes Disponibles ({{filteredPackages.length}})</h2>
        
        <!-- Buscador (Movido aquí) -->
        <div class="relative">
          <input 
            type="text" 
            [(ngModel)]="searchTerm" 
            placeholder="Buscar paquete..." 
            class="pl-8 pr-3 py-1 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm w-48"
          >
          <i class="fas fa-search absolute left-2.5 top-2 text-gray-400 text-xs"></i>
        </div>
      </div>
      
      <!-- Lista Scrollable -->
      <div class="space-y-3 overflow-y-auto flex-1 pr-2">
        <div 
          *ngFor="let package of filteredPackages" 
          class="p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition-colors"
          [class.bg-blue-50]="selectedPackage?.packageNumber === package.packageNumber"
          (click)="selectPackage(package.packageNumber)"
        >
          <div class="flex justify-between items-start">
            <div class="flex-1">
              <h3 class="font-medium text-gray-900">{{ package.packageNumber }}</h3>
              <p class="text-sm text-gray-600">{{ package.name }}</p>
              <div class="flex items-center space-x-2 mt-2">
                <span class="px-2 py-1 text-xs rounded-full" 
                      [class]="package.type === 'empaquetado' ? 'bg-blue-100 text-blue-800' : 
                               package.type === 'cargado' ? 'bg-green-100 text-green-800' : 
                               'bg-purple-100 text-purple-800'">
                  {{ getPackageType(package) }}
                </span>
                <span class="px-2 py-1 text-xs rounded-full" 
                      [class]="package.status === 'active' ? 'bg-green-100 text-green-800' : 
                               package.status === 'completed' ? 'bg-blue-100 text-blue-800' : 
                               'bg-red-100 text-red-800'">
                  {{ getPackageStatus(package) }}
                </span>
              </div>
              <p class="text-sm text-gray-500 mt-1">
                {{ package.totalItems || 0 }} repuestos •
                <ng-container *ngIf="package.loadedToTruckAt; else createdFallback">
                  Cargado (camión): {{ package.loadedToTruckAt | date:'short' }}
                </ng-container>
                <ng-template #createdFallback>
                  Creado: {{ package.createdAt ? (package.createdAt | date:'short') : 'N/D' }}
                </ng-template>
              </p>
            </div>
            <div class="flex space-x-1">
              <button
                (click)="reprintPackageLabels(package); $event.stopPropagation()"
                class="text-purple-600 hover:text-purple-800 p-1 relative"
                [title]="packageLabelsPrinted[package.packageNumber] ? 'Reimprimir etiqueta del paquete (Ya impresa)' : 'Imprimir etiqueta del paquete'"
              >
                <i class="fas fa-tag"></i>
                <i *ngIf="packageLabelsPrinted[package.packageNumber]" class="fas fa-check text-green-600 text-xs absolute -top-1 -right-1"></i>
              </button>
              <button
                (click)="reprintSparePartLabels(package); $event.stopPropagation()"
                class="text-blue-600 hover:text-blue-800 p-1 relative"
                [title]="sparePartLabelsPrinted[package.packageNumber] ? 'Reimprimir etiquetas de repuestos (Ya impresas)' : 'Imprimir etiquetas de repuestos'"
              >
                <i class="fas fa-tags"></i>
                <i *ngIf="sparePartLabelsPrinted[package.packageNumber]" class="fas fa-check text-green-600 text-xs absolute -top-1 -right-1"></i>
              </button>
              <button
                (click)="confirmDeletePackage(package.packageNumber); $event.stopPropagation()"
                class="text-red-600 hover:text-red-800 p-1"
                title="Eliminar paquete"
              >
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
        
        <!-- Mensaje sin resultados de búsqueda -->
        <div *ngIf="filteredPackages.length === 0 && packages.length > 0" class="text-center py-8 text-gray-500">
            No se encontraron paquetes que coincidan con "{{searchTerm}}"
        </div>
      </div>
    </div>

    <!-- Detalles del paquete seleccionado (Panel Derecho) -->
    <div class="flex flex-col min-h-0">
        <div *ngIf="selectedPackage" class="bg-white rounded-lg shadow-md p-6 h-full flex flex-col overflow-hidden relative">
          
          <!-- Loading Overlay Específico para detalles -->
          <div *ngIf="loadingDetails" class="absolute inset-0 bg-white bg-opacity-80 z-10 flex flex-col justify-center items-center">
             <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-2"></div>
             <span class="text-sm text-gray-500">Cargando detalles...</span>
          </div>

      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold">Detalles del Paquete</h2>
        <div class="flex space-x-2">
          <button
            (click)="reprintPackageLabels(selectedPackage)"
            class="bg-purple-500 hover:bg-purple-600 text-white px-3 py-1 rounded text-sm relative"
            [title]="packageLabelsPrinted[selectedPackage.packageNumber] ? 'Reimprimir etiqueta del paquete (Ya impresa)' : 'Imprimir etiqueta del paquete'"
          >
            <i class="fas fa-tag mr-1"></i>Etiqueta Paquete
            <i *ngIf="packageLabelsPrinted[selectedPackage.packageNumber]" class="fas fa-check text-green-600 text-xs absolute -top-1 -right-1"></i>
          </button>
          <button
            (click)="reprintSparePartLabels(selectedPackage)"
            class="bg-indigo-500 hover:bg-indigo-600 text-white px-3 py-1 rounded text-sm relative"
            [title]="sparePartLabelsPrinted[selectedPackage.packageNumber] ? 'Reimprimir etiquetas de repuestos (Ya impresas)' : 'Imprimir etiquetas de repuestos'"
          >
            <i class="fas fa-tags mr-1"></i>Etiquetas Repuestos
            <i *ngIf="sparePartLabelsPrinted[selectedPackage.packageNumber]" class="fas fa-check text-green-600 text-xs absolute -top-1 -right-1"></i>
          </button>
          <button
            (click)="showAddSparePartToPackageModal()"
            class="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm"
          >
            <i class="fas fa-plus mr-1"></i>Agregar Repuesto
          </button>
          <button
            (click)="confirmDeletePackage(selectedPackage.packageNumber)"
            class="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm"
          >
            <i class="fas fa-trash mr-1"></i>Eliminar
          </button>
        </div>
      </div>

      <div class="mb-4">
        <h3 class="font-medium text-gray-900">{{ selectedPackage.packageNumber }}</h3>
        <p class="text-sm text-gray-600">{{ selectedPackage.name }}</p>
        <div class="flex items-center space-x-2 mt-2">
          <span class="px-2 py-1 text-xs rounded-full" 
                [class]="selectedPackage.type === 'empaquetado' ? 'bg-blue-100 text-blue-800' : 
                         selectedPackage.type === 'cargado' ? 'bg-green-100 text-green-800' : 
                         'bg-purple-100 text-purple-800'">
            {{ getPackageType(selectedPackage) }}
          </span>
          <span class="px-2 py-1 text-xs rounded-full" 
                [class]="selectedPackage.status === 'active' ? 'bg-green-100 text-green-800' : 
                         selectedPackage.status === 'completed' ? 'bg-blue-100 text-blue-800' : 
                         'bg-red-100 text-red-800'">
            {{ getPackageStatus(selectedPackage) }}
          </span>
        </div>
      </div>

      <!-- Repuestos del paquete -->
      <div class="flex-1 overflow-y-auto min-h-0 pr-2">
        <h4 class="font-medium text-gray-900 mb-3 sticky top-0 bg-white py-2">Repuestos en el Paquete</h4>
        <div class="space-y-2">
          <div 
            *ngFor="let sparePart of selectedPackage.spareParts" 
            class="p-3 border rounded-lg bg-gray-50"
          >
            <div class="flex justify-between items-start">
              <div class="flex-1">
                <p class="font-medium text-sm">{{ sparePart.sparePartName }}</p>
                <p class="text-xs text-gray-600">Código: {{ sparePart.productCode }}</p>
                <p class="text-xs text-gray-600">Orden: {{ sparePart.orderNumber }}</p>
                <p class="text-xs text-gray-600">Estado: {{ sparePart.productStatus }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Información adicional -->
      <div class="mt-4 p-3 bg-blue-50 rounded-lg flex-shrink-0">
        <h4 class="font-medium text-blue-900 mb-2">Información Importante</h4>
        <ul class="text-sm text-blue-800 space-y-1">
          <li>• Solo se pueden agregar repuestos de la misma orden</li>
          <li>• Al eliminar el paquete, los repuestos volverán a su estado original</li>
          <li>• Los repuestos no pueden estar en múltiples paquetes</li>
        </ul>
      </div>
    </div>
    
    <!-- Placeholder cuando no hay paquete seleccionado -->
    <div *ngIf="!selectedPackage" class="bg-gray-50 rounded-lg border border-dashed border-gray-300 p-6 flex items-center justify-center text-gray-500 h-full">
        <div class="text-center">
            <i class="fas fa-box-open text-4xl mb-3 opacity-50"></i>
            <p>Selecciona un paquete para ver sus detalles</p>
        </div>
    </div>
  </div>

  <!-- Mensaje cuando no hay paquetes -->
  <div *ngIf="!loading && packages.length === 0" class="text-center py-8 flex-1 flex flex-col justify-center">
    <i class="fas fa-box-open text-4xl text-gray-400 mb-4"></i>
    <h3 class="text-lg font-medium text-gray-900 mb-2">No hay paquetes disponibles</h3>
    <p class="text-gray-600">Los paquetes aparecerán aquí una vez que se generen etiquetas y se empaqueten repuestos.</p>
  </div>

  <!-- Modal de confirmación de eliminación -->
  <div *ngIf="showDeleteConfirmation" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
      <div class="flex items-center mb-4">
        <i class="fas fa-exclamation-triangle text-red-500 text-2xl mr-3"></i>
        <h3 class="text-lg font-medium text-gray-900">Confirmar Eliminación</h3>
      </div>
      
      <p class="text-gray-600 mb-6">
        ¿Estás seguro de que quieres eliminar el paquete <strong>{{ packageToDelete }}</strong>? 
        Esta acción restaurará todos los repuestos a su estado original y no se puede deshacer.
      </p>
      
      <div class="flex justify-end space-x-3">
        <button 
          (click)="cancelDelete()"
          class="px-4 py-2 text-gray-600 border border-gray-300 rounded hover:bg-gray-50"
        >
          Cancelar
        </button>
        <button 
          (click)="deletePackage()"
          [disabled]="loading"
          class="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 disabled:opacity-50"
        >
          <span *ngIf="loading" class="animate-spin mr-2">⏳</span>
          Eliminar
        </button>
      </div>
    </div>
  </div>

  <!-- Modal para agregar repuestos al paquete -->
  <div *ngIf="showAddSparePartModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 max-w-4xl w-full mx-4 max-h-[80vh] overflow-hidden">
      <div class="flex items-center justify-between mb-4">
        <h3 class="text-lg font-medium text-gray-900">
          Agregar Repuestos al Paquete {{ selectedPackage?.packageNumber }}
        </h3>
        <button 
          (click)="closeAddSparePartModal()"
          class="text-gray-400 hover:text-gray-600"
        >
          <i class="fas fa-times text-xl"></i>
        </button>
      </div>
      
      <div class="mb-4 p-3 bg-blue-50 rounded-lg">
        <p class="text-sm text-blue-800">
          <i class="fas fa-info-circle mr-2"></i>
          Solo se muestran repuestos de la misma orden que no están asignados a ningún paquete.
        </p>
      </div>

      <!-- Loading spinner -->
      <div *ngIf="loadingAvailableParts" class="flex justify-center items-center py-8">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span class="ml-2 text-gray-600">Cargando repuestos disponibles...</span>
      </div>

      <!-- Lista de repuestos disponibles -->
      <div *ngIf="!loadingAvailableParts" class="max-h-96 overflow-y-auto">
        <div *ngIf="availableSpareParts.length === 0" class="text-center py-8">
          <i class="fas fa-box text-4xl text-gray-400 mb-4"></i>
          <h4 class="text-lg font-medium text-gray-900 mb-2">No hay repuestos disponibles</h4>
          <p class="text-gray-600">
            Todos los repuestos de esta orden ya están asignados a paquetes o no hay repuestos sin asignar.
          </p>
        </div>

        <div *ngIf="availableSpareParts.length > 0" class="space-y-3">
          <div 
            *ngFor="let sparePart of availableSpareParts" 
            class="p-4 border rounded-lg hover:bg-gray-50 transition-colors"
          >
            <div class="flex justify-between items-start">
              <div class="flex-1">
                <p class="font-medium text-sm">{{ sparePart.sparePartNameEs || sparePart.sparePartName }}</p>
                <p class="text-xs text-gray-600">Código: {{ sparePart.productCode }}</p>
                <p class="text-xs text-gray-600">Orden: {{ sparePart.orderNumber }}</p>
                <p class="text-xs text-gray-600">Estado: {{ sparePart.productStatus }}</p>
              </div>
              <button 
                (click)="addSparePartToPackage(sparePart.sparePartId)"
                [disabled]="loading"
                class="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm disabled:opacity-50"
              >
                <span *ngIf="loading" class="animate-spin mr-2">⏳</span>
                <i class="fas fa-plus mr-1"></i>Agregar
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Botones del modal -->
      <div class="flex justify-end space-x-3 mt-6 pt-4 border-t">
        <button 
          (click)="closeAddSparePartModal()"
          class="px-4 py-2 text-gray-600 border border-gray-300 rounded hover:bg-gray-50"
        >
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>

